import { Injector } from "@angular/core";

export let AppInjector: Injector;

export function setAppInjector(injector: Injector) {
    if (AppInjector) {
        console.error('there was a programming error');
    } else {
        AppInjector = injector;
    }
}